module.exports = __webpack_public_path__ + "img/mdn-logo-text.90dbecb5.png";